// 设置购物车数据
export const SET_CART_DATA = 'SET_CART_DATA';
// 设置购物车商品列表
export const SET_CART_LIST = 'SET_CART_LIST';

// 设置顶部提示条隐藏
export const SET_TIPS_HIDE = 'SET_TIPS_HIDE';

// 隐藏税金的遮罩
export const SET_TAX_MASK_HIDE = 'SET_TAX_MASK_HIDE';
// 显示税金遮罩
export const SET_TAX_MASK_SHOW = 'SET_TAX_MASK_SHOW';

// 显示toast提示框
export const SET_TOAST_SHOW = 'SET_TOAST_SHOW';
// 隐藏toast提示框
export const SET_TOAST_HIDE = 'SET_TOAST_HIDE';
// 设置toast提示文本框
export const SET_TOAST_TEXT = 'SET_TOAST_TEXT';

// 显示loading图标
export const SET_LOADING_SHOW = 'SET_LOADING_SHOW';
// 隐藏loading图标
export const SET_LOADING_HIDE = 'SET_LOADING_HIDE';

// 设置编辑状态
export const SET_EDIT_TRUE = 'SET_EDIT_TRUE';
// 设置费编辑状态
export const SET_EDIT_FALSE = 'SET_EDIT_FALSE';

export const SET_CONFIRM_SHOW = 'SET_CONFIRM_SHOW';
export const SET_CONFIRM_HIDE = 'SET_CONFIRM_HIDE';
export const SET_CONFIRM_DATA = 'SET_CONFIRM_DATA';



// WEBPACK FOOTER //
// ./src/store/mutation_types.js